import React from "react";
import { Alert } from "react-bootstrap";
import "./snackBar.scss";

const SnackbarMessage = ({ open, message, severity = "success", onClose }) => {
    if (!open) return null;

    const variantMap = {
        success: "success",
        error: "danger",
        warning: "warning",
        info: "info",
    };

    return (
        <div className="snackbar-container">
            <Alert
                variant={variantMap[severity] || "info"}
                onClose={onClose}
                dismissible
                className="snackbar-alert"
            >
                {message}
            </Alert>
        </div>
    );
};

export default SnackbarMessage;
